<template>
    <section>
        <div class="groups">
            <div v-for="(button, index) in buttons"
                 :key="index"
                 :class="{'active': valueIndex == index}"
                 class="buttons" 
                 @click="changeEvent(button, index)">
                {{ button }}
            </div>
        </div>
    </section>
</template>

<script>
	export default {
		props: {
			buttons: {
				type: Array,
				default() {
					return ['button1', 'button2', 'button3']
				}
			},
			setButton: {
				type: String,
				default: ''
			}
		},
		data () {
			return {
				valueIndex: 0
			}
		},
		created() {
			//busca outro tipo de botão para setar o buttom 
			this.$watch('setButton', (val) => {
				this.buttons.map((value, index)=> {
					if (value == val) {
						this.valueIndex = index
						this.$emit('input', value)
					}				
				});
			})
		},

		methods: {
			changeEvent(val, index) {
				this.valueIndex = index
				this.$emit('input', val)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
